import React from 'react';
import {Link} from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import ReactGA from 'react-ga';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import * as Strings from '../../constants';

ReactGA.initialize('UA-157458781-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class Phases extends React.Component{

  filterPhases = () => {
      console.log('Scenario as known in phase: ', this.props.scenario);
    let allPhases = this.props.phases;
      console.log('allPhases: ', allPhases);
    let phases = allPhases.filter(ps => ps[ 'Scenario' ] === this.props.scenario);
      console.log('Phases: ', phases);
    return phases;
  }

  render() {

    const phases = this.filterPhases();
    return(
        <div className="phasesOverview">
          <Row>
            {
              phases.map(obj => {
                return (
                  <Col key={obj.Nr}>
                    <div className={"phase " + obj.Nr}>
                      <p className="tag scenarioBd">Phase {obj.Nr}</p>
                      <h2 className="title">{obj.Title}</h2>
                      <p className="description">
                        <ReactMarkdown
                          source={obj.Description}
                          disallowedTypes={['paragraph']}
                          unwrapDisallowed={true}
                        />
                      </p>
                      <Link to={`/s/${this.props.scenario}/phase-${obj.Nr}`}>
                        <button>{Strings.ExplorePhase}</button>
                      </Link>
                    </div>
                  </Col>
                )
              })
            }
          </Row>
        </div>
    )
  }
}
export default Phases;



// WEBPACK FOOTER //
// ./src/components/Phases/phases.js